import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import {
  ChorinicityType,
  PregnancyType,
} from '@app/modules/service-data/types/service-data.types';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOptionComponent } from '@shared/components/select/select-option/select-option.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-service-data-form-pregnancy-type',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    ValidationErrorComponent,
    InputValidationStatusDirective,
    SelectComponent,
    SelectOptionComponent,
  ],
  templateUrl: './service-data-form-pregnancy-type.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormPregnancyTypeComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected readonly PregnancyType = PregnancyType;
  protected readonly Object = Object;
  protected readonly ChorinicityType = ChorinicityType;

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.form
      .get('pregnancyType')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((pregnancyType: PregnancyType) => {
        if (pregnancyType !== PregnancyType.twins) {
          this.form.get('chorionicityType').reset(null);
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
